/**
 * Dash redirect function, exported to test
 */
export const redirectToEventDash = (history, event) => {
  history.push(`/dash/team/${event.team}/event/${event._id}/dashboard`);
};
